module.exports = __webpack_public_path__ + "files/234045c3efb0d2b1a28219d4116d9b1b.png";